import React from 'react';
import { useTranslation } from 'react-i18next';
import { WebcamVideo } from '@/components/Icons/WebcamVideo';

interface Props {
  className?: string;
}

export const LessonVideoChip: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <span
      className={`inline-flex shrink-0 items-center gap-1 rounded-xl bg-info-surface px-2 py-0.5 ${className ?? ''}`}
    >
      <WebcamVideo className="size-4 shrink-0 text-primary" />
      <span className="text-caption-12 whitespace-nowrap text-foreground">
        {t('mail.video.type.lesson')}
      </span>
    </span>
  );
};
